// applicationService.js
import apiClient from './api';

/**
 * 获取申请初始化数据
 * @returns {Promise<Object>} 后端返回的申请数据
 */
export async function getApplicationInitData() {
  try {
    const res = await apiClient.get('/api/applications');
    return res.data;
  } catch (error) {
    throw error;
  }
}

/**
 * 获取材料列表
 * @param {Object} params - 请求参数
 * @param {string|number} params.s_id - 学校ID
 * @param {string} params.degree - 学位类型 (Bachelor/Master/Doctor)
 * @returns {Promise<Object>} 材料列表数据
 */
export async function getMaterialList(params) {
  try {
    const response = await apiClient.get('/api/materials_list', { params });
    
    if (response.success && response.data && response.data.data) {
      const materials = response.data.data;
      
      // 将API返回的材料列表转换为文件组格式，包含文件信息
      const fileGroups = materials.map((material, index) => ({
        key: material.id || `material_${index}`, // 使用API返回的id作为key
        label: material.MaterialName || material.name || `材料${index + 1}`,
        requirement: material.MaterialRequirement || material.requirement || null,
        example: material.Example || material.example || null,
        ifnecessary: material.IfNecessary || 0,
        // 添加文件信息字段
        path: material.path || '',
        name: material.name || material.MaterialName || `材料${index + 1}`
      }));
      
      return fileGroups;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
}

/**
 * 从申请数据中提取材料列表
 * @param {Object} applicationData - 申请数据
 * @returns {Array} 材料列表
 */
export function extractMaterialsFromApplication(applicationData) {
  if (!applicationData || !applicationData.materials) {
    return [];
  }
  
  const materials = applicationData.materials;
  const materialList = [];
  
  // 遍历materials对象，提取材料信息
  Object.entries(materials).forEach(([materialId, fileData]) => {
    // 如果fileData是数组且为空，说明该材料未上传
    if (Array.isArray(fileData) && fileData.length === 0) {
      materialList.push({
        id: materialId,
        uploaded: false,
        fileData: null
      });
    } 
    // 如果fileData是对象且包含path，说明该材料已上传
    else if (fileData && typeof fileData === 'object' && fileData.path) {
      materialList.push({
        id: materialId,
        uploaded: true,
        fileData: fileData
      });
    }
  });
  
  return materialList;
}

/**
 * 更新材料信息
 * @param {FormData} formData - 包含材料文件的FormData
 * @returns {Promise<Object>} 更新结果
 */
export async function updateMaterials(formData) {
  try {
    const response = await apiClient.post('/api/application/update-materials', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    
    if (response.success) {
      return {
        success: true,
        data: response.data,
        message: response.message
      };
    } else {
      throw new Error(response.message || '材料更新失败');
    }
  } catch (error) {
    throw error;
  }
}
